/*
 * Module for managing the site's theme
 */

rs.module("ui/framework/theme-manager", 
    
    ["ui/framework/sass-exports", "ui/framework/userstate-manager", "controls/data/chart-themes"],

    function (sassExports, userStateManager, chartThemes) {

        var _themes = sassExports.data("site-themes");
        var _thirdPartyThemes = sassExports.data("third-party-themes");
        var _chartThemeNames = sassExports.data("chart-themes");

        var _setThemeUrl;

        var _onThemeChangedCallbacks = [];

        //
        // Initialize the theme manager
        //
        function initialize(setThemeUrl) {
            _setThemeUrl = setThemeUrl;
        }

        //
        // Gets the list of available theme names
        //
        function getThemeNames() {
            return Object.getOwnPropertyNames(_themes);
        }

        //
        // Sets the overall site theme
        //
        function setTheme(theme) {

            var removeClass = getThemeCssClass(getTheme());
            var addClass = getThemeCssClass(theme);

            var gridRemoveClass = getGridThemeCssClass(getTheme());
            var gridAddClass = getGridThemeCssClass(theme);

            var htmlEditorRemoveClass = getHtmlEditorThemeCssClass(getTheme());
            var htmlEditorAddClass = getHtmlEditorThemeCssClass(theme);
            
            if (typeof addClass === "undefined") {
                throw new Error("Theme '" + theme + "' is not valid.");
            }

            $(".grid").removeClass(gridRemoveClass);
            $(".grid").addClass(gridAddClass);

            $(".html-editor").removeClass(htmlEditorRemoveClass);
            $(".html-editor").addClass(htmlEditorAddClass);

            $("html").removeClass(removeClass);
            $("html").addClass(addClass);

            // Post back the state for server side storage.
            $.post(_setThemeUrl, { theme });

            // create properties object to be sent to each theme-changed callback
            let themeProperties = {
                themeClass: addClass,
                thirdPartyClasses: _thirdPartyThemes[theme],
                chartTheme: getChartTheme(theme)
            }

            // execute each theme-changed callback that has been registered
            _onThemeChangedCallbacks.forEach(function (callback) {
                callback.call(null, themeProperties);
            });
        }

        //
        // Gets the current theme
        //
        function getTheme() {
            for (var name in _themes) {
                var cssClass = getThemeCssClass(name);

                if (cssClass != "" && $("html").hasClass(cssClass)) {
                    return name;
                }
            }

            return "root";
        }

        //
        // Gets the css class for the given theme, or throws if the theme is not a valid theme name
        //
        function getThemeCssClass(theme) {
            var cssClass = _themes[theme];

            if (typeof cssClass === "undefined") {
                throw new Error("Theme '" + theme + "' is not valid.");
            }

            return cssClass;
        }

        //
        // Gets the grid's css class for the given theme, or throws if the theme is not a valid theme name
        //
        function getGridThemeCssClass(theme) {

            var cssClass = _thirdPartyThemes[theme]["grid"];
            return cssClass;
        }

        //
        // Gets the html editor's css class for the given theme, or throws if the theme is not a valid theme name
        //
        function getHtmlEditorThemeCssClass(theme) {

            var cssClass = _thirdPartyThemes[theme]["html-editor"];
            return cssClass;
        }

        //
        // Get the chart theme for a given theme
        //
        function getChartTheme(theme) {

            if (theme == null) {
                theme = getTheme();
            }

            var themeName = _chartThemeNames[theme];

            return chartThemes[themeName];
        }

        //
        // Function to allow consumers to specify a call back function to execute when a theme has been changed
        //
        function onThemeChanged(onThemeChanged) {

            _onThemeChangedCallbacks.push(onThemeChanged);
        }

        // Exported public API
        var exports = {
            initialize,
            onThemeChanged,
            getChartTheme
        };

        // Add theme list getter\setter
        Object.defineProperty(exports, 'themeNames',
            {
                get: getThemeNames,
            });

        // Add theme getter\setter
        Object.defineProperty(exports, 'theme',
            {
                get: getTheme,
                set: setTheme
            });

        return exports;
    }
);